import type React from 'react'
import {SideBar} from 'pepsico-ds'
import type {ISideBarProps} from 'pepsico-ds'

// Using type instead of interface since we're not adding any properties
interface SidebarWrapperProps extends ISideBarProps {
  isDark?: boolean
}

const SidebarWrapper: React.FC<SidebarWrapperProps> = ({
  // Basic sidebar configuration
  items,
  activeItem,
  navLinkAction,
  showCollapsed,
  onToggle,

  // Styling properties
  height,
  width,
  collapseWidth,
  className,
  style,
  backdropStyle,

  // Bottom section properties
  bottomImg,
  bottomText,
  bottomAction,
  showBottomAction,

  // Indicator configuration
  isBottomIndicator,

  // Mobile responsiveness properties
  isOverlay,
  isShow,
  onClose,

  // Theme
  isDark,

  // Rest of the props (HTML div attributes)
  ...rest
}) => {
  return (
    <SideBar
      data-is-dark={isDark}
      // Basic sidebar configuration
      items={items}
      activeItem={activeItem}
      navLinkAction={navLinkAction}
      showCollapsed={showCollapsed}
      onToggle={onToggle}
      // Styling properties
      height={height}
      width={width}
      collapseWidth={collapseWidth}
      className={className}
      style={style}
      backdropStyle={backdropStyle}
      // Bottom section properties
      bottomImg={bottomImg}
      bottomText={bottomText}
      bottomAction={bottomAction}
      showBottomAction={showBottomAction}
      // Indicator configuration
      isBottomIndicator={isBottomIndicator}
      // Mobile responsiveness properties
      isOverlay={isOverlay}
      isShow={isShow}
      onClose={onClose}
      // Rest of the props
      {...rest}
    />
  )
}

export default SidebarWrapper
